import { useEffect } from 'react';

// AskDD chatbot widget configuration. We load the script lazily via
// requestIdleCallback (or a setTimeout fallback) so it never blocks
// LCP / hydration — but the loader is intentionally a standalone
// component that mounts once at the Layout level. Keeping it separate
// from `ChatbotLabel` ensures dismissing the label (which unmounts that
// component) never prevents the chat agent itself from loading.
const ASKDD_WIDGET_SRC = 'https://widget.askdd.net/widget.js';
const ASKDD_CONFIG = {
  apiKey: 'dd_dd-consu_x_mE6oYfhz967ATkNkDXYcwInVxoM9oLdJbe0-4CfQE',
  tenantId: 'dd-consult-main-6wk8df',
};

function injectWidget() {
  if (typeof window === 'undefined') return;
  if (document.querySelector(`script[src="${ASKDD_WIDGET_SRC}"]`)) return;

  const script = document.createElement('script');
  script.src = ASKDD_WIDGET_SRC;
  script.async = true;
  script.defer = true;
  script.onload = () => {
    if (window.DDChatbotWidget && typeof window.DDChatbotWidget.init === 'function') {
      try {
        window.DDChatbotWidget.init(ASKDD_CONFIG);
      } catch (err) {
        // Widget already initialised — safe to ignore.
        // eslint-disable-next-line no-console
        console.warn('[AskDD] init skipped:', err?.message);
      }
    }
  };
  document.body.appendChild(script);
}

export default function AskDDLoader() {
  useEffect(() => {
    // Idle-callback (with timeout) on supported browsers, plain
    // setTimeout fallback on Safari < 18.1 / older Firefox. Note: we
    // deliberately do NOT cancel the callback on unmount — once the
    // page has been visited, we always want the agent script to land,
    // even if this component is later unmounted by a parent.
    if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
      window.requestIdleCallback(injectWidget, { timeout: 4000 });
    } else {
      setTimeout(injectWidget, 2500);
    }
  }, []);

  return null;
}
